const EPISODIC_CITATION = "40 CFR 262 subpart L";

export type RuleSource = {
  label: string;
  color: "default" | "info";
  /** Rendered by `EpisodicBadge` rather than the generic source chip. */
  isEpisodic: boolean;
};

/** Which body of law a clock limit comes from, for the source badge. */
export function deriveRuleSource(limit: { citation: string; jurisdiction: string }): RuleSource {
  if (limit.citation === EPISODIC_CITATION) {
    // Blue, like every other episodic marker — see `EpisodicBadge`, which is
    // what draws the fact everywhere the rule-source badge isn't. A state
    // badge is blue too, but says "CA"; these two never read as each other.
    return { label: "Episodic", color: "info", isEpisodic: true };
  }
  if (limit.jurisdiction === "FEDERAL") {
    return { label: "Federal", color: "default", isEpisodic: false };
  }
  return { label: limit.jurisdiction, color: "info", isEpisodic: false };
}
